import { render, staticRenderFns } from "./postSearchInput.vue?vue&type=template&id=209cc9f6&"
import script from "./postSearchInput.vue?vue&type=script&lang=js&"
export * from "./postSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports